import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Release outbox record DTO
 */
export class ReleaseOutboxRecordDto {
	dispatchToken!: string;
	@TransformDate()
	dispatchedAt?: Date;
	dispatchError?: string;
	/**
	 * Lease identity from the tick that dispatched this row. Absent on older
	 * callers, which still release any leased row for the token.
	 */
	leasedBy?: string;
}
